import useSWR from "swr"

import { useSoftLoginDataFromLocalStorage } from "hooks/useSoftLoginDataFromLocalStorage"
import { apiFavClient } from "services/apiFavClient"
import { selectUserBasicDetails } from "stores/auth/authSlice"
import { useAppSelector } from "stores/hooks"

const fetcher = async () => {
  const response = await apiFavClient.getAllFavoritePropertyIds()
  setTimeout(() => {
    void (async () => {
      const mixpanelV2Client = (await import("services/mixpanelv2"))
        .mixpanelV2Client
      mixpanelV2Client.SET_NUMBER_OF_PROPERTIES_FAVORITED(
        response?.data?.data?.length || 0,
      )
    })()
  }, 1)
  return response?.data?.data || []
}

const useFavorites = () => {
  const userBasicDetails = useAppSelector(selectUserBasicDetails)
  const { softLoginData } = useSoftLoginDataFromLocalStorage()
  return (
    useSWR(
      userBasicDetails?.userId || softLoginData?.userId
        ? `/api/getFavoritePropertyIds`
        : null,
      fetcher,
      {
        loadingTimeout: 15000,
        keepPreviousData: true,
        revalidateOnFocus: false,
        dedupingInterval: 3000,
        errorRetryCount: 3,
      },
    ).data || []
  )
}

export default useFavorites
